import { ComponentType } from "react";
import { MobileFooterId } from "../../common/mobileFooter";
import { MobileFooterVariantProps } from "./shared/types";
import GamesSixFooter from "./variants/GamesSixFooter";
import RaisedHomeFooter from "./variants/RaisedHomeFooter";
import HomeGlowFooter from "./variants/HomeGlowFooter";
import GamesFiveFooter from "./variants/GamesFiveFooter";

type FooterComponent = ComponentType<Omit<MobileFooterVariantProps, "footerId">>;

/**
 * Eager registry — all footers ship in the main bundle so the selected
 * id renders immediately (no lazy flash). Add a new footer by:
 * 1) creating variants/YourFooter.tsx
 * 2) adding styles in styles/components/mobileFooters/_yourId.scss
 * 3) registering it here + in common/mobileFooter.ts
 */
export const MOBILE_FOOTER_REGISTRY: Record<MobileFooterId, FooterComponent> = {
  "games-six": GamesSixFooter,
  default: RaisedHomeFooter,
  "home-arc": HomeGlowFooter,
  "games-five": GamesFiveFooter,
};

export const getMobileFooterComponent = (
  id: MobileFooterId
): FooterComponent =>
  MOBILE_FOOTER_REGISTRY[id] || MOBILE_FOOTER_REGISTRY["games-six"];
